import React from "react";
import { useBreadcrumbsState } from "./hooks.js";
import { BreadcrumbsContext } from "./types.js";
function BreadcrumbsProvider({ children }) {
  const value = useBreadcrumbsState();
  return /* @__PURE__ */ React.createElement(BreadcrumbsContext.Provider, { value }, children);
}
export {
  BreadcrumbsProvider
};
//# sourceMappingURL=BreadcrumbsProvider.js.map
